import { tv } from 'tailwind-variants'

export const itemFooter = tv(
  {
    slots: {
      container: 'flex gap-x-micro items-center text-sub',
      span: 'font-bold',
      icon: 'text-primary-medium text-centi'
    }
  },
  { twMerge: false }
)
